import React from 'react'

export const TypingIndicator: React.FC<{ label: string }> = ({ label }) => (
  <div className="wc-row">
    <div className="wc-typing" aria-label={label} role="status">
      <i />
      <i />
      <i />
    </div>
  </div>
)
